<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import { ddlHelper, sessionHelper } from "@/utils";
import { SESSION } from "@/constants";
import { required } from "vuelidate/lib/validators";
import { mapState } from "vuex";
import i18n from '@/i18n'
import { LOOKUP_MODULE } from '@/state/modules/lookup'
import { ROLE_MODULE } from '@/state/modules/role'
import { roleMethods, lookupMethods  } from "@/state/helpers";

const checkFalse = (value) => value != false;

export default {
  page: {
    title: i18n.t('label.createX', [i18n.t('module.role')]),
  },
  components: { Layout, PageHeader },
  beforeRouteLeave(to, from, next) {
    if (to.name != "role-listing") {
      sessionHelper.clearSearch(SESSION.ROLE_SEARCH);
    }
    next();
  },
  computed: {
    ...mapState(ROLE_MODULE, ["status"]),
    ...mapState(LOOKUP_MODULE),
    permissionDdl() {
      return this.$store.state.lookup.permissionDdl;
    },
  },
  data() {
    return {
      title: i18n.t('label.createX', [i18n.t('module.role')]),
      items: [
        {
          text: i18n.t('module.dashboard'),
          href: "/",
        },
        {
          text: i18n.t('module.role'),
          href: "/role",
        },
        {
          text: i18n.t('label.createX', [i18n.t('module.role')]),
          active: true,
        },
      ],
      submitted: false,
      statusDdl: ddlHelper.getActivationStatus(false, true),
      permissions: sessionHelper.getPermissions(),
      createPermission: null, 
      createForm: {
          name: "", 
          permissions: []
      }
    };
  },
  validations: {
    createForm: {
      name: { required },
      permissions: { checkFalse },
    },
  },
  async created() {
    await this.validPermissions();
    this.getPermissionDdl();
  },
  methods: {
    ...roleMethods,
    ...lookupMethods,
    async validPermissions(){ 
      var jsonPermissions = JSON.parse(this.permissions)
      if(jsonPermissions.some(p => p.code === "USER_URC")) {
       this.createPermission = true; 
      }
      else {
        this.createPermission = false; 
      }
    },
    getPermissionDdl() {
      this.lookupPermission({ hasOptionAll: false, });
    },
    requestCreate() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        let data = {
          name: this.createForm.name,
          permissions: this.createForm.permissions,
        };

        if(this.createPermission == true) {
          this.createRole({ data });
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="requestCreate" v-if="createPermission == true">
              <b-form-group
                id="name"
                label-cols-sm="2"
                label-cols-lg="2"
                :label="$t('label.name')"
                label-for="name"
              >
                <b-form-input
                  for="name"
                  v-model.trim="createForm.name"
                  :class="{ 'is-invalid': submitted &&!$v.createForm.name.required }"
                ></b-form-input>
                <div v-if="submitted && !$v.createForm.name.required" class="invalid-feedback">
                  <span v-if="!$v.createForm.name.required">{{
                    $t("message.requiredX", [$t("label.name")])
                  }}</span>
                </div>
              </b-form-group>


              <div class="form-group row mb-0">
                <label class="col-md-2 col-form-label">Select Permission</label>

                <div class="row">
                  <div
                    class="col-sm-5 py-2"
                    v-for="permission in permissionDdl"
                    v-bind:key="permission.submodule"
                  >
                    <b-form-group :label="permission.submodule">
                      <div
                        class="form-check"
                        v-for="permissionData in permission.permissions"
                        v-bind:key="permissionData.code"
                      >
                        <b-form-checkbox
                          type="checkbox"
                          v-bind:value="permissionData.code"
                          v-bind:id="permissionData.code"
                          v-model="createForm.permissions"
                        >
                          {{ permissionData.label }}
                        </b-form-checkbox>
                      </div>
                    </b-form-group>
                  </div>
                </div>
                <div
                    v-if="!$v.createForm.permissions.checkFalse"
                    style="color: #ff3d60; font-size: 80%"
                  >
                    <span v-if="submitted && !$v.createForm.permissions.checkFalse">{{
                      $t("message.atLeastOneSelectedX", [$t("label.permission")])
                    }}</span>
                  </div>
              </div>
              <button
                class="btn btn-primary w-md waves-effect waves-light"
                style="margin-right: 10px"
                type="submit"
                :disabled="status.create"
              >
                {{ $t("label.createX", [$t('module.role')]) }}
              </button>
            </form>
            <div style="text-align: center;" v-else>
                {{ $t('message.noPermissionMessage') }}
              </div>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
  </Layout>
</template>